const publics = {
    //当前资产统计
    columns1: [
        {
            title: '昵称',
            dataIndex: 'accountName',
            align: "center",
            width: 120,
        },
        {
            title: '用户ID',
            dataIndex: 'accountNO',
            align: "center",
            width: 140,
        },
        {
            title: '注册电话',
            dataIndex: 'phone',
            align: "center",
            width: 140,
        },
        {
            title: '活跃时间',
            dataIndex: 'loginDateTime',
            align: "center",
            width: 160,
        },
        {
            title: '当前资产（泰贝）',
            dataIndex: 'amount',
            align: "center",
            width: 150,
        },
        {
            title: '流量包',
            dataIndex: 'fluxPackets',
            align: "center",
            width: 120,
        },
        {
            title: '储存包',
            dataIndex: 'capacityPackets',
            align: "center",
            width: 120,
        },
        {
            title: '语音包（分钟）',
            dataIndex: 'use9',
            align: "center",
            width: 140,
        },
        {
            title: '预付费直播间（个） ',
            dataIndex: 'prepayments',
            align: "center",
            width: 160,
        },
        {
            title: '预付费语音对讲',
            dataIndex: 'use11',
            align: "center",
            width: 160,
        },
        {
            title: '充值',
            dataIndex: 'operate',
            align: "center",
            width: 90,
            slots: {
                customRender: 'operate',
            },
        },
    ],
    //当前资产明细
    columns2: [
        {
            title: '昵称',
            dataIndex: 'accountName',
            align: "center",
            width: 160,
        },
        {
            title: '用户ID',
            dataIndex: 'accountNO',
            align: "center",
            width: 160,
        },
        {
            title: '注册电话',
            dataIndex: 'phone',
            align: "center",
            width: 160,
        },
        {
            title: '服务类型',
            dataIndex: 'consumeType',
            align: "center",
            width: 400,
            customRender: function (text, record, index) {
                if (text.text === 2) {
                    return "流量包";
                } else if (text.text === 3) {
                    return "容量包";
                } else if (text.text === 5) {
                    return "预付费包";
                } else {
                    return "未知类型";
                }
            }
        },
        {
            title: '资源',
            dataIndex: 'productName',
            align: "center",
            width: 310,
        },
        {
            title: '生效时间',
            dataIndex: 'rechargeDateTime',
            align: "center",
            width: 200,
        },
        {
            title: '失效时间',
            dataIndex: 'expireDateTime',
            align: "center",
            width: 200,
        },
    ],
    //收益详情
    columns3: [
        {
            title: '昵称',
            dataIndex: 'accountName',
            align: "center",
            width: 120,
        },
        {
            title: '用户ID',
            dataIndex: 'accountNO',
            align: "center",
            width: 140,
        },
        {
            title: '注册电话',
            dataIndex: 'phone',
            align: "center",
            width: 140,
        },
        {
            title: '服务类型',
            dataIndex: 'serviceType',
            align: "center",
            width: 180,
            customRender: function (text, record, index) {
                if (text.text === 0) {
                    return "流量";
                } else if (text.text === 1) {
                    return "容量";
                } else if (text.text === 2) {
                    return "流量包";
                } else if (text.text === 3) {
                    return "容量包";
                } else if (text.text === 4) {
                    return "预付费直播间"
                } else if (text.text === 5) {
                    return "预付费直播间包"
                } else {
                    return "未知类型";
                }
            }
        },
        {
            title: '资源包',
            dataIndex: 'productName',
            align: "center",
            width: 180,
        },
        {
            title: '开始日期',
            dataIndex: 'startTime',
            align: "center",
            width: 130,
        },
        {
            title: '结束日期',
            dataIndex: 'endTime',
            align: "center",
            width: 130,
        },
        {
            title: '收入',
            dataIndex: 'amount',
            align: "center",
            width: 140,
        },
        {
            title: '消耗量',
            dataIndex: 'flux',
            align: "center",
            width: 140,
        },
    ],
    //充值统计
    columns4: [
        {
            title: '昵称',
            dataIndex: 'accountName',
            align: "center",
            width: 120,
        },
        {
            title: '用户ID',
            dataIndex: 'accountNO',
            align: "center",
            width: 140,
        },
        {
            title: '注册电话',
            dataIndex: 'phone',
            align: "center",
            width: 140,
        },
        {
            title: '充值时间',
            dataIndex: 'consumeDateTime',
            align: "center",
            width: 180,
        },
        {
            title: '充值额度',
            dataIndex: 'realAmount',
            align: "center",
            width: 180,
        },
        {
            title: '利率',
            dataIndex: 'rate',
            align: "center",
            width: 120,
        },
        {
            title: '获得资产（泰贝）',
            dataIndex: 'amount',
            align: "center",
            width: 130,
        },
        {
            title: '充值后余额（泰贝）',
            dataIndex: 'rechargedAfterAmount',
            align: "center",
            width: 130,
        }
    ],
    //资源包管理
    columns5: [
        {
            title: '服务类型',
            dataIndex: 'productType',
            align: "center",
            width: 240,
            slots: {
                customRender: 'productType',
            },
        },
        {
            title: '资源包名称 ',
            dataIndex: 'productName',
            align: "center",
            width: 240,
            slots: {
                customRender: 'productName',
            },
        },
        {
            title: '描述',
            dataIndex: 'description',
            align: "center",
            width: 380,
            slots: {
                customRender: 'description',
            },
        },
        {
            title: '售价（泰贝）',
            dataIndex: 'amount',
            align: "center",
            width: 180,
            slots: {
                customRender: 'amount',
            },
        },
        {
            title: '资源数量',
            dataIndex: 'value',
            align: "center",
            width: 180,
            slots: {
                customRender: 'value',
            },
        },
        {
            title: '有效期（天）',
            dataIndex: 'expirationDuration',
            align: "center",
            width: 180,
            slots: {
                customRender: 'expirationDuration',
            },
        },
        {
            title: '操作',
            dataIndex: 'operation',
            align: "center",
            width: 180,
            slots: {
                customRender: 'operation',
            },
        },
    ],
}
export default publics
